import { useEffect, useRef } from 'react'
import { getSafeEditorDom } from './getSafeEditorDom'

export function useComposerMentionEnterKey(editor, refs, mentionFlatItems, insertMention) {
  const { mentionOpenRef, mentionActiveIndexRef } = refs
  const flatRef = useRef(mentionFlatItems)
  flatRef.current = mentionFlatItems

  useEffect(() => {
    if (!editor || editor.isDestroyed) return
    const dom = getSafeEditorDom(editor)
    if (!dom) return
    const onKeyDown = (event) => {
      if (!mentionOpenRef.current || event.key !== 'Enter' || event.shiftKey) return
      const picked = flatRef.current[mentionActiveIndexRef.current]
      if (!picked) return
      event.preventDefault()
      insertMention(picked)
    }
    dom.addEventListener('keydown', onKeyDown)
    return () => dom.removeEventListener('keydown', onKeyDown)
  }, [editor, insertMention, mentionActiveIndexRef, mentionOpenRef])
}
